<template>
  <div>
    <a-divider />
    <a-card :bordered="false">
      <a-breadcrumb style="margin-bottom: 10px" separator=">">
        <a-breadcrumb-item v-if="source=='my'"
          ><router-link to="/user/course"
            >我的课程</router-link
          ></a-breadcrumb-item
        >
        <a-breadcrumb-item v-else
          ><router-link to="/course"
            >课程列表</router-link
          ></a-breadcrumb-item
        >
        <a-breadcrumb-item>浏览课程</a-breadcrumb-item>
      </a-breadcrumb>
      <a-row type="flex" justify="space-between" :gutter="_isMobile()?10:40">
        <a-col :flex="_isMobile()?1:'450px'" :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
          <a-skeleton v-if="!info.courseCover"/>
          <img class="cover" v-if="info.courseCover" :src="info.courseCover_url" alt="">
        </a-col>
        <a-col :flex="_isMobile()?1:'auto'" :xs="24" :sm="24" :md="14" :lg="14" :xl="14">
          <h3>{{info.courseName}}</h3>
          <p>{{info.courseDesc}}</p>
          <br><br>
          <p  class="gray"><pre>{{info.courseComment}}</pre></p>
        </a-col>
      </a-row>
    </a-card>
    <a-divider />
    <a-card v-if="info.showType==3" :bordered="false">
        <h3 class="title">章节</h3>
        <a-list :dataSource="courseUnitDataSource">
          <a-list-item slot="renderItem" slot-scope="item" @click="toCourse(item)">
              <h3 class="title">{{ item.unitName }}</h3>
              <a-button slot="actions" size="small"
                  ><span v-if="item.isFreeSee" style="margin-right: 8px; color: red;">可试看</span>点击进入学习<a-icon type="right"/></a-button
                >
          </a-list-item>
        </a-list>
    </a-card>
    <a-card v-if="info.showType==2" :bordered="false" class="app-list">
      <a-list :grid="{ gutter: 24, xxl:4, xl:4, lg: 3, md: 2, sm: 1, xs: 1 }" :dataSource="courseUnitDataSource">
          <a-list-item slot="renderItem" slot-scope="item" @click="toCourse(item)">
            <a-card @click="viewUnit(item)">
              <!-- <template class="ant-card-extra" slot="extra">
                <span class="create-time">{{item.createTime}}</span>
              </template> -->
              <a-card-meta>
                <div style="margin-bottom: 3px" slot="title">
                  <a-icon type="right-circle" />&nbsp;&nbsp;
                  {{ item.unitName }}
                </div>
                <div class="meta-cardInfo" slot="description">
                  <img :src="item.unitCover_url" height="25px" alt="图片不存在" style="width: 100%; height: 100%" />
                </div>
              </a-card-meta>
            </a-card>
          </a-list-item>
        </a-list>
    </a-card>
    <a-card v-if="info.showType==1">
      <div class="course-map-wrap" :style="{backgroundImage: `url(${info.courseMap_url})`}">
        <div v-for="unit in courseUnitDataSource" :key="unit.id" class="unit" 
          :style="{left: unit.mapX-25+'px', top: unit.mapY-25+'px'}"
          @click="toCourse(unit)">
            <i class="flag" :style="{backgroundImage: info.courseMapIcon_url?`url(${info.courseMapIcon_url})`:`url(/img/position.png)`}"></i>
            <div class="unit-title">{{unit.unitName}}</div>
        </div>
        <unitView-modal ref="unitViewModal"/>
      </div>
    </a-card>
    <unitView-modal ref="unitViewModal" />
  </div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG,ACCESS_TOKEN } from "@/store/mutation-types";
import {getAction, postAction} from "@/api/manage"
import {mixinDevice} from '@/utils/mixin.js'
import UnitViewModal from '@/components/course/UnitViewModal'
export default {
  mixins: [mixinDevice],
  components:{
    UnitViewModal
  },
  data(){
    return{
      id:'',
      departId: '',
      source: '',
      courseUnitDataSource:[
        {id:'123', unitName: '章节'}
      ],
      info: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      token: '',
      tenantConfig:{}
    }
  },
  created() {
    this.tenantConfig = Vue.ls.get(TENANT_CONFIG);
    this.id = this.$route.query.id
    this.source = this.$route.query.source
    this.departId = this.$route.query.departId
    this.getInfo()
    if (Vue.ls.get(ACCESS_TOKEN)){
      this.token = Vue.ls.get(ACCESS_TOKEN)
    }
  },
   mounted(){
    window.document.title = this.tenantConfig.brandName + " " +  "课程详情"
  },
  methods: {
    getInfo(){
      getAction("/teaching/teachingCourse/get",{id: this.id}).then(res=>{
        if(res.success){
          this.info = res.result
          this.getList()
        }
      })
    },
    getList(){
      if(this.departId){
        getAction("/teaching/teachingCourseUnit/mineUnit",{courseId: this.id, departId: this.departId}).then(res=>{
          if(res.success){
            this.courseUnitDataSource = res.result.records
          }
        })
      }else{
        getAction("/teaching/teachingCourseUnit/showCourseUnit",{courseId: this.id}).then(res=>{
          if(res.success){
            this.courseUnitDataSource = res.result
          }
        })
      }

    },
    toCourse(unit){
      // if(!unit.departId){
      //   this.$message.info('本课程仅做展示，请从个人中心进入课程')
      //   return
      // }
      console.log(unit);
      if(unit.isUnitOpen == 0 || (unit.isUnitOpen == 2 && unit.openTime > unit.serverTime)){
        this.$message.info("未开课")
        return
      }
      this.$refs.unitViewModal.view(unit)
    }
  },
};
</script>

<style lang="less" scoped>
.gray{
    color: gray;
}
.cover{
  width: 100%;
}
.detail{
  overflow-x: scroll;
}
.title{
  font-size: 15px;
  line-height: 22px;
  margin-bottom: 0;
  overflow: hidden;
}
.ant-list-item{
  cursor: pointer;
  border-radius: 8px;
  padding-left: 12px;
}
.ant-list-item:hover{
  background: #e8e8e8;
}

  .course-map-wrap{
    background-repeat: no-repeat;
    background-size: auto;
    height: 1000px;
  }

  .unit{
    width: 50px;
    height: 0;
    position: relative;
    display: block;
    .flag{
        display: block;
        width: 64px;
        height: 64px;
        // background: url("/img/position.png") no-repeat;
        background-size: 64px 64px;
        // margin: 10px 0;
        // border-radius: 0px 18px 31px 18px;
        // transform: rotate(225deg);
        // background: radial-gradient(#aedbe6, #57b0f3d4, #128fec);;
        // -webkit-box-shadow:rgba(66,140,240,0.5) 0px 10px 16px;
    }
    .unit-title{
        // background-color: #52c41ab3;
        display: block; 
        width: 64px;
        padding: 0.4em 0em 0em;
        font-size: 100%;
        font-weight: 700;
        line-height: 1;
        color: #fff;
        text-align: center;
        // white-space: nowrap;
        vertical-align: baseline;
        border-radius: .25em;
        text-shadow: 0px 0px 5px black;
    }
  }


.app-list {
  .ant-card {
    max-height: 250px;
    /deep/.ant-card-body{
      padding: 12px;
    }
  }
  
  .meta-cardInfo {
    zoom: 1;
    margin-top: 16px;
    .title {
      margin-right: 20px;
    }
    img {
      width: 100%;
      max-height: 200px;
    }
    > div {
      position: relative;
      text-align: left;
      float: left;
      width: 50%;

      p {
        line-height: 32px;
        font-size: 24px;
        margin: 0;

        &:first-child {
          color: rgba(0, 0, 0, 0.45);
          font-size: 12px;
          line-height: 20px;
          margin-bottom: 4px;
        }
      }
    }
  }
}
</style>